// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_q7P","toggle":"styles_toggle__h-TTA","preview":"styles_preview__3aqkM"};